/**
 * RÈGLES DE SET — source unique.
 *
 * Fichier dupliqué à l'identique dans les deux dépôts (front : `src/utils/set-rules.ts`,
 * back : `src/common/utils/set-rules.ts`). La parité est contrôlée par
 * `scripts/verifier-parite-regles.mjs` (hook de pré-commit) : modifier les deux copies ensemble.
 */

export const SET_POINTS = 25;
export const TIE_BREAK_POINTS = 15;

/**
 * Le tie-break est le dernier set possible du match : le 5ᵉ en 3 sets gagnants,
 * le 3ᵉ en 2 sets gagnants. Un match en un set n'en a pas.
 */
export function isTieBreakSet(setNumber: number, setsToWin: number = 3): boolean {
  return setsToWin >= 2 && setNumber === setsToWin * 2 - 1;
}

export function setPointTarget(setNumber: number, setsToWin: number = 3): number {
  return isTieBreakSet(setNumber, setsToWin) ? TIE_BREAK_POINTS : SET_POINTS;
}

/** Set gagné : points cibles atteints avec deux points d'écart. */
export function isSetOver(us: number, them: number, setNumber: number, setsToWin: number = 3): boolean {
  const target = setPointTarget(setNumber, setsToWin);
  return (us >= target || them >= target) && Math.abs(us - them) >= 2;
}

/** The match ends as soon as one side has won `setsToWin` sets (2 for youth or leisure matches). */
export function isMatchOver(setsWonUs: number, setsWonThem: number, setsToWin: number = 3): boolean {
  return setsWonUs >= setsToWin || setsWonThem >= setsToWin;
}